import { useQuery } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

export const endpoints = {
  GET_CONFIGURED_MANUAL_PAYMENT_PROCESSORS: 'manual-payments/get-configured-processors',
};

export const manualPaymentProcessorsQueryKey = 'manual-payments-configured-processors';

export type ManualPaymentProcessor = {
  IsEnabled: boolean;
  LocId: number;
  LspId: number;
  ManualPaymentProcessorId: number;
  ManualPaymentProcessorName: string;
  ManualPaymentSettingsId: number;
};

// Mirrors register's useEnabledNonIntegratedPaymentsProcessors() (apps/register/src/queries/v2/payments/manual-payments.ts) -
// same endpoint/response shape, just re-implemented here since mobile-checkout doesn't share
// register's query layer.
export function useManualPaymentProcessorsQuery(enabled = false) {
  const baseAPIParams = useBaseAPIParams();

  return useQuery({
    queryKey: [manualPaymentProcessorsQueryKey, baseAPIParams.LspId, baseAPIParams.LocId],
    queryFn: async () => {
      return await post<ManualPaymentProcessor[]>(endpoints.GET_CONFIGURED_MANUAL_PAYMENT_PROCESSORS, baseAPIParams);
    },
    enabled,
  });
}

export function useEnabledManualPaymentProcessors(enabled = false) {
  const { data, isLoading } = useManualPaymentProcessorsQuery(enabled);
  const processors = data?.filter((processor) => processor.IsEnabled) ?? [];
  return {
    hasEnabledManualPaymentProcessors: processors.length > 0,
    isLoading,
    processors,
  };
}
